import { DocumentsFolderItemFragment } from 'generated/resources/graphql'

import {
  isContractType,
  isCostCenterType,
  isEmployeeDataType,
  isHiringType,
  isLeaveType,
  isLegalEntityType,
  isManualType,
  isTerminationType,
} from 'modules/payroll_bundle/lib/Incidences/TypeHelpers'

import ContractLinks from './ContractLinks'
import { CostCenterLinks } from './CostCenterLinks'
import EmployeeDataLinks from './EmployeeDataLinks'
import HiringLinks from './HiringLinks'
import LegalEntityLinks from './LegalEntityLinks'
import ManualLinks from './ManualLinks'
import NewAbsenceLinks from './NewAbsenceLinks'
import TerminationLinks from './TerminationLinks'

interface Props {
  incidenceType: string
  employeeId: number
  legalEntityId: number
  companyId: number
  targetId?: number | null
  folders: DocumentsFolderItemFragment[]
}

export const Links = ({
  incidenceType,
  employeeId,
  legalEntityId,
  companyId,
  targetId,
  folders,
}: Props) => {
  if (isTerminationType(incidenceType)) {
    return (
      <TerminationLinks
        employeeId={employeeId}
        companyId={companyId}
        legalEntityId={legalEntityId}
        folders={folders}
      />
    )
  }

  if (isHiringType(incidenceType)) {
    return (
      <HiringLinks
        employeeId={employeeId}
        companyId={companyId}
        legalEntityId={legalEntityId}
        folders={folders}
      />
    )
  }

  if (isLeaveType(incidenceType)) {
    return (
      targetId && (
        <NewAbsenceLinks
          employeeId={employeeId}
          companyId={companyId}
          legalEntityId={legalEntityId}
          targetId={targetId}
          folders={folders}
        />
      )
    )
  }

  if (isContractType(incidenceType)) {
    return (
      <ContractLinks
        employeeId={employeeId}
        companyId={companyId}
        legalEntityId={legalEntityId}
        folders={folders}
      />
    )
  }

  if (isManualType(incidenceType)) {
    return <ManualLinks employeeId={employeeId} companyId={companyId} />
  }

  if (isLegalEntityType(incidenceType)) {
    return (
      <LegalEntityLinks
        employeeId={employeeId}
        companyId={companyId}
        legalEntityId={legalEntityId}
      />
    )
  }

  if (isCostCenterType(incidenceType)) {
    return (
      <CostCenterLinks
        employeeId={employeeId}
        companyId={companyId}
        legalEntityId={legalEntityId}
      />
    )
  }

  if (isEmployeeDataType(incidenceType)) {
    return (
      <EmployeeDataLinks
        employeeId={employeeId}
        companyId={companyId}
        legalEntityId={legalEntityId}
      />
    )
  }

  return null
}
